import { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getWebview } from '@cian/webview/webview';

import { selectPayment } from '../../../selectors/payment';
import { usePaymentTracking } from './usePaymentTracking';
import { EPaymentStatus } from '../../../types/payment';
import { BEGIN_AGAIN_URL, FINISH_URL } from '../constants';
import { useWebView } from '../../../utils/webView';

export interface IUsePaymentResult {
  paymentStatus?: EPaymentStatus;
  paymentId?: string;
  finishAction: {
    url?: string;
    handler: () => void;
  };
  beginAgainAction: {
    url: string;
    handler: () => void;
  };
}

export function usePayment(): IUsePaymentResult {
  const { isWebView } = useWebView();
  const { trackFinish, trackBeginAgain, trackStatusChange } = usePaymentTracking();
  const { paymentId, paymentStatus } = useSelector(selectPayment);

  useEffect(() => {
    trackStatusChange();
  }, [trackStatusChange]);

  const finishAction = useMemo(() => {
    if (isWebView) {
      return {
        handler: () => {
          trackFinish();
          getWebview().close();
        },
      };
    }

    return {
      url: FINISH_URL,
      handler: trackFinish,
    };
  }, [trackFinish, isWebView]);

  const onBeginAgain = useCallback(() => {
    trackBeginAgain();
  }, [trackBeginAgain]);

  return {
    paymentId,
    paymentStatus,
    finishAction,
    beginAgainAction: {
      url: BEGIN_AGAIN_URL,
      handler: onBeginAgain,
    },
  };
}
